<template>
  <div class="about-us-page">
    <!-- 引入头部导航 -->
    <AppHeader />

    <!-- 主要内容区 大图背景模块 -->
    <main class="about-us-main-content">
      <img class="bg-img" src="https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731161023034.jpg" alt="关于我们背景" />
      <div class="about-us-text-content">
        <h1>关于我们</h1>
        <p>了解我们的公司历史、使命和价值观</p>
      </div>
    </main>

    <!-- 公司信息区块 - 图片和蓝色拼接布局 -->
    <section class="company-info-section scroll-reveal">
      <!-- 背景层 -->
      <div class="background-container">
        <div class="background-image"></div>
        <div class="background-blue"></div>
      </div>

      <!-- 压在上面的图片 -->
      <div class="floating-image">
        <img src="../assets/images/homepage/spec-pics/spec-pic1.png" alt="公司图片" />
      </div>

      <!-- 右侧文字内容 -->
      <div class="text-section">
        <h2>Who is QianShou?</h2>
        <p>千手医疗，合肥千手医疗科技有限责任公司于2019年成立于合肥国家大学科技园，是一家专业的 医疗信息化解决方案提供商，致力于为用户提供优质的软件产品和技术服务。公司及知名
          互联网企业，专注医疗信息化10余年，拥有丰富的行业建设经验，是中国医疗行业信息化 的开创者和领跑者！公司位于合肥国家大学科技园，公司以"打造智慧医疗服务，提升医疗 服务获得感”为使命，整合优质资源提供更好的服务。</p>
        <p>公司目前拥有11项软件著作权，3项核心技术专利，并与多家医疗机构达成战略合作关系，为其定制化打造专属的新型互联网医疗系统。</p>
        <p>目前，千手医疗已获得多项国家和行业认可，包括国家高新技术企业、国家级知识产权优势企业等荣誉称号。</p>
      </div>
    </section>

    <!-- 企业发展区块 -->
    <section class="company-development-section scroll-reveal delay-1">
      <!-- 标题和描述 -->
      <div class="development-header">
        <h2>企业发展</h2>
        <p>千手医疗将为人类健康事业做出应有的贡献。</p>
      </div>

      <!-- 标签切换区域 -->
      <div class="tabs-container">
        <div v-for="(tab, index) in tabs" :key="index" :class="['tab', { active: activeTab === index }]"
          @mouseenter="switchTab(index)">
          {{ tab.name }}
        </div>
      </div>

      <!-- 内容展示区域 -->
      <div class="development-content">
        <!-- 背景层 -->
        <div class="development-background">
          <div class="background-left-image">
            <img :src="tabs[activeTab].image" :alt="tabs[activeTab].name" />
          </div>
          <div class="background-right-white"></div>
        </div>

        <!-- 浮动内容盒子 -->
        <div class="floating-content-box">
          <h3>{{ tabs[activeTab].title }}</h3>
          <p v-for="(paragraph, idx) in tabs[activeTab].content" :key="idx">{{ paragraph }}</p>
        </div>
      </div>
    </section>

    <!-- 企业经营区块 -->
    <section class="company-development-section scroll-reveal delay-2">
      <!-- 标题和描述 -->
      <div class="development-header text-right">
        <h2>企业经营</h2>
        <p>千手医疗为客户提供产品服务，并推动医疗科技的进步和发展。</p>
      </div>

      <!-- 标签切换区域 -->
      <div class="tabs-container justify-end">
        <div v-for="(tab, index) in operationTabs" :key="index"
          :class="['tab', { active: activeOperationTab === index }]" @mouseenter="switchOperationTab(index)">
          {{ tab.name }}
        </div>
      </div>

      <!-- 内容展示区域 -->
      <div class="development-content">
        <!-- 背景层 -->
        <div class="development-background">
          <div class="background-left-image">
            <img :src="operationTabs[activeOperationTab].image" :alt="operationTabs[activeOperationTab].name" />
          </div>
          <div class="background-right-white"></div>
        </div>

        <!-- 浮动内容盒子 -->
        <div class="floating-content-box">
          <h3>{{ operationTabs[activeOperationTab].title }}</h3>
          <p v-for="(paragraph, idx) in operationTabs[activeOperationTab].content" :key="idx">{{ paragraph }}</p>
        </div>
      </div>
    </section>

    <!-- 服务与人才区块 -->
    <section class="company-development-section scroll-reveal delay-3">
      <!-- 标题和描述 -->
      <div class="development-header">
        <h2>服务与人才</h2>
        <p>千手医疗关注和重视客户需求，致力于为客户提供全方位、个性化的优质服务。</p>
      </div>

      <!-- 标签切换区域 -->
      <div class="tabs-container">
        <div v-for="(tab, index) in serviceTabs" :key="index" :class="['tab', { active: activeServiceTab === index }]"
          @mouseenter="switchServiceTab(index)">
          {{ tab.name }}
        </div>
      </div>

      <!-- 内容展示区域 -->
      <div class="development-content">
        <!-- 背景层 -->
        <div class="development-background">
          <div class="background-left-image">
            <img :src="serviceTabs[activeServiceTab].image" :alt="serviceTabs[activeServiceTab].name" />
          </div>
          <div class="background-right-white"></div>
        </div>

        <!-- 浮动内容盒子 -->
        <div class="floating-content-box">
          <h3>{{ serviceTabs[activeServiceTab].title }}</h3>
          <p v-for="(paragraph, idx) in serviceTabs[activeServiceTab].content" :key="idx">{{ paragraph }}</p>
        </div>
      </div>
    </section>

    <!-- 质量方针与执行力区块 -->
    <section class="company-development-section scroll-reveal delay-4">
      <!-- 标题和描述 -->
      <div class="development-header text-right">
        <h2>质量方针与执行力</h2>
        <p>科技创新和高品质是千手发展的坚固基石</p>
      </div>

      <!-- 标签切换区域 -->
      <div class="tabs-container justify-end">
        <div v-for="(tab, index) in qualityTabs" :key="index" :class="['tab', { active: activeQualityTab === index }]"
          @mouseenter="switchQualityTab(index)">
          {{ tab.name }}
        </div>
      </div>

      <!-- 内容展示区域 -->
      <div class="development-content">
        <!-- 背景层 -->
        <div class="development-background">
          <div class="background-left-image">
            <img :src="qualityTabs[activeQualityTab].image" :alt="qualityTabs[activeQualityTab].name" />
          </div>
          <div class="background-right-white"></div>
        </div>

        <!-- 浮动内容盒子 -->
        <div class="floating-content-box">
          <h3>{{ qualityTabs[activeQualityTab].title }}</h3>
          <p v-for="(paragraph, idx) in qualityTabs[activeQualityTab].content" :key="idx">{{ paragraph }}</p>
        </div>
      </div>
    </section>

    <!-- 引入底部 -->
    <AppFooter />
  </div>
</template>

<script>
// 导入头部和底部组件
import AppHeader from './AppHeader.vue';
import AppFooter from './AppFooter.vue';

export default {
  name: 'AboutUs',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      activeTab: 1, // 默认选中发展使命
      tabs: [
        {
          name: '发展愿景',
          title: '发展愿景：成为医疗健康领域的全球领导者',
          content: [
            '千手医疗的发展愿景是成为医疗健康领域的全球领导者，通过持续创新和卓越服务，为全球患者提供最优质的医疗解决方案。',
            '公司致力于在创伤修复、智慧医疗和家庭理疗等领域建立全球领先地位，推动医疗技术的进步，改善人类健康福祉。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic1.png')
        },
        {
          name: '发展使命',
          title: '发展使命：以科技领先 给生命承诺',
          content: [
            '千手医疗的这一发展使命意味着，公司致力于通过科技的不断进步，为患者提供更加先进、有效的医疗设备，以提高人类的健康质量。同时，公司承诺始终关注患者的需求，致力于为他们提供更好的医疗服务和解决方案。',
            '千手医疗的发展使命体现了其对科技进步和患者福祉的承诺，致力于通过科技的力量，为人类健康事业做出贡献。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic2.png')
        },
        {
          name: '经营战略',
          title: '经营战略：创新驱动 质量为本',
          content: [
            '千手医疗的经营战略以创新驱动和质量为本的核心，通过持续的技术创新和严格的质量管理，提升产品竞争力和市场份额。',
            '公司注重研发投入，不断推出符合市场需求的新产品，同时加强全球营销网络建设，拓展国际市场，实现可持续发展和持续进步。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic3.png')
        },
        {
          name: '核心价值观',
          title: '核心价值观：诚信、创新、卓越、责任',
          content: [
            '诚信是千手医疗的立业之本，公司始终坚持诚实经营，信守承诺；创新是公司发展的动力源泉，不断推动技术和管理创新；卓越是公司的追求目标，致力于提供卓越的产品和服务；责任是公司的使命担当，积极履行社会责任，回馈社会。',
            '这些价值观指导着千手医疗的日常运营和长远发展，是公司文化的重要组成部分。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic4.jpg')
        }
      ],
      // 企业经营标签数据
      operationTabs: [
        {
          name: '经营理念',
          title: '经营理念：发展才是硬道理',
          content: [
            '在千手医疗28年的发展历程中，始终强调为企业的重要性。只有不断发展壮大企业，才能在激烈的市场竞争中立于不败之地，实现千手的长远发展和实现千手的企业使命。',
            '千手医疗在业务经营发展的过程中，在科技创新、产品多样化和市场拓展多个维度上取得了长足的发展。公司注重研发投入，致力于开发具有国际领先水平的高性能医疗设备，并积极拓展国内外市场，与全球合作伙伴建立紧密合作关系，共同推动了所在领域内医疗科技的发展。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic5.jpg')
        },
        {
          name: '管理理念',
          title: '管理理念：以人为本，科学管理',
          content: [
            '千手医疗坚持以人为本的管理理念，注重人才培养和团队建设，为员工提供广阔的发展空间和良好的工作环境。公司尊重员工的创新精神和专业能力，鼓励员工积极参与公司管理和决策过程。',
            '同时，千手医疗推行科学管理方法，健全traditional企业管理制度，优化业务流程，提高运营效率，确保公司各项业务的高效、规范运行，为公司的持续发展奠定坚实基础。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic1.png')
        }
      ],
      activeOperationTab: 0,
      // 服务与人才标签数据
      serviceTabs: [
        {
          name: '服务理念',
          title: '服务理念：用户就是上帝，24小时闻讯而动的售后服务',
          content: [
            '旨在为客户提供全方位、个性化的服务，满足客户的不同需求。',
            '千手医疗注重产品的差异化和个性化，并可以根据客户需求进行定制化开发，以满足客户的特定需求。千手医疗提供专业的售后服务和技术支持，包括延长保修、推广维修、上门培训、学术与技术支持等方面，以保证客户能够享受到高品质、高价值的产品和服务。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic2.png')
        },
        {
          name: '人才理念',
          title: '人才理念：人才是企业发展的第一资源',
          content: [
            '千手医疗视人才为企业发展的核心竞争力，高度重视人才的引进、培养和发展。公司建立了完善的人才培养体系和激励机制，为人才提供广阔的发展空间和良好的成长环境。',
            '千手医疗注重员工的专业技能提升和综合素质培养，鼓励员工不断学习和创新，为员工提供丰富的培训和学习机会，帮助员工实现个人价值与企业发展的有机统一。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic3.png')
        }
      ],
      activeServiceTab: 0,
      // 质量方针与执行力标签数据
      qualityTabs: [
        {
          name: '质量方针',
          title: '质量方针：科技为本，质量第一',
          content: [
            '千手医疗将科技创新作为公司发展的基石，注重高科技医疗电子产品的研发和生产，不断推动创新的技术创新和产品升级。',
            '千手医疗把质量视为企业的生命线，是公司竞争力的核心，公司通过不断优化生产工艺及流程、提高产品质量控制标准和出厂检验，以及强化员工质量意识和专业技能，致力于提供安全、可靠、高质量的医疗设备产品，以期达到预期的治疗效果和医疗体验。',
            '同时，千手医疗持续改进和创新，不断探索新技术、新工艺、新材料，以提升产品质量和性能。质量提升是公司发展战略的重要组成部分，将引导千手医疗朝着更品质、更高效率、更具创新力的方向发展。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic4.jpg')
        },
        {
          name: '执行力',
          title: '执行力：高效执行，使命必达',
          content: [
            '千手医疗强调执行力的重要性，认为高效的执行力是实现企业战略目标的关键。公司建立了完善的执行机制和监督体系，确保各项工作能够高效、有序地推进和落实。',
            '千手医疗注重团队协作和沟通，鼓励员工积极主动地承担责任，勇于挑战和突破，以高度的责任感和使命感完成各项工作任务，为实现公司的发展目标和企业使命而努力奋斗。'
          ],
          image: require('@/assets/images/homepage/spec-pics/spec-pic5.jpg')
        }
      ],
      activeQualityTab: 0
    };
  },
  // 方法会在mounted之后的methods对象中重新定义
  directives: {
    // 自定义滚动显示指令
    'scroll-reveal': {
      inserted(el) {
        el.classList.add('scroll-reveal');
        // 检查元素是否在视口中
        const checkVisibility = () => {
          const rect = el.getBoundingClientRect();
          const windowHeight = window.innerHeight || document.documentElement.clientHeight;

          // 当元素顶部进入视口底部100px以内时显示
          if (rect.top <= windowHeight - 100) {
            el.classList.add('active');
            window.removeEventListener('scroll', checkVisibility);
          }
        };

        // 初始检查
        checkVisibility();
        // 添加滚动监听
        window.addEventListener('scroll', checkVisibility);
      }
    }
  },
  mounted() {
    // 处理路由参数，自动选中对应的标签页
    this.handleRouteParams();

    // 为所有带有scroll-reveal类的元素添加初始检查
    const checkAllElements = () => {
      const elements = document.querySelectorAll('.scroll-reveal');
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        if (rect.top <= windowHeight - 100) {
          el.classList.add('active');
        }
      });
    };

    // 初始检查所有元素
    checkAllElements();

    // 添加滚动事件监听
    window.addEventListener('scroll', checkAllElements);

    // 页面大小改变时重新检查
    window.addEventListener('resize', checkAllElements);

    // 组件销毁时移除事件监听
    this.$options.beforeDestroy = () => {
      window.removeEventListener('scroll', checkAllElements);
      window.removeEventListener('resize', checkAllElements);
    };
  },
  methods: {
    // 处理路由参数，自动选中对应的标签页
    handleRouteParams() {
      // 获取路由参数
      const tabType = this.$route.query.tabType;
      const tabIndex = parseInt(this.$route.query.tabIndex, 10);

      // 如果参数存在且有效，则设置对应的标签为激活状态
      if (tabType && !isNaN(tabIndex)) {
        switch (tabType) {
          case 'development':
            this.activeTab = tabIndex;
            break;
          case 'operation':
            this.activeOperationTab = tabIndex;
            break;
          case 'service':
            this.activeServiceTab = tabIndex;
            break;
          case 'quality':
            this.activeQualityTab = tabIndex;
            break;
        }

        // 滚动到对应的区块（稍微延迟以确保DOM已经渲染）
        setTimeout(() => {
          this.scrollToTabSection(tabType);
        }, 100);
      }
    },

    // 从小变大动画效果，并滚动到标题位置
    scrollToTabSection(tabType) {
      // 直接使用更精确的方法获取各个区块
      const sections = document.querySelectorAll('.company-development-section');
      let sectionElement = null;

      // 根据tabType选择对应的区块
      if (tabType === 'development' && sections[0]) {
        sectionElement = sections[0];
      } else if (tabType === 'operation' && sections[1]) {
        sectionElement = sections[1];
      } else if (tabType === 'service' && sections[2]) {
        sectionElement = sections[2];
      } else if (tabType === 'quality' && sections[3]) {
        sectionElement = sections[3];
      }

      // 如果找不到对应的区块，使用默认区块
      if (!sectionElement && sections.length > 0) {
        sectionElement = sections[0];
      }

      if (sectionElement) {
        // 添加缩放动画类
        sectionElement.classList.add('scale-animation');

        // 获取区块内的标题元素（development-header）
        const headerElement = sectionElement.querySelector('.development-header');
        if (headerElement) {
          // 计算标题位置，让标题显示在顶部偏下的位置（距离顶部100px）
          const headerPosition = headerElement.getBoundingClientRect().top + window.pageYOffset - 300;

          // 平滑滚动到指定位置
          window.scrollTo({
            top: headerPosition,
            behavior: 'smooth'
          });
        }

        // 动画结束后移除类，以便下次点击时可以重新触发
        setTimeout(() => {
          sectionElement.classList.remove('scale-animation');
        }, 1000);
      }
    },

    switchTab(index) {
      this.activeTab = index;
    },
    switchOperationTab(index) {
      this.activeOperationTab = index;
    },
    switchServiceTab(index) {
      this.activeServiceTab = index;
    },
    switchQualityTab(index) {
      this.activeQualityTab = index;
    }
  }
}
</script>

<style>
@import url(../../style/aboutUs/aboutUs.css);
@import url(../../style/aboutUs/companyInfo.css);
@import url(../../style/aboutUs/companyDevelopment.css);
@import url(../../style/aboutUs/scrollAnimation.css);
</style>